import { createContext, useState, ReactNode, useMemo } from 'react';

import { BreadcrumbProps } from 'components/Breadcrumb';

export type BreadcrumbContextProps = {
  breadcrumbData?: BreadcrumbProps;
  setBreadcrumbData: React.Dispatch<
    React.SetStateAction<BreadcrumbProps | undefined>
  >;
};
export const BreadcrumbContext = createContext<BreadcrumbContextProps>(
  undefined!,
);

export const BreadcrumbProvider = (props: { children: ReactNode }) => {
  const [breadcrumbData, setBreadcrumbData] = useState<BreadcrumbProps>();

  const memoizedReturn = useMemo(
    () => ({
      breadcrumbData,
      setBreadcrumbData,
    }),
    [breadcrumbData, setBreadcrumbData],
  );

  return (
    <BreadcrumbContext.Provider value={memoizedReturn}>
      {props.children}
    </BreadcrumbContext.Provider>
  );
};
